import { useEffect, useRef, useState } from "react";
import { fmt } from "@/lib/demo/utils";
import { useI18n } from "@/lib/i18n/i18n";

export const KpiNumber = ({ value, className = "", testId, format = fmt }) => {
  const [bump, setBump] = useState(0);
  const prev = useRef(value);
  useEffect(() => {
    if (prev.current !== value) {
      prev.current = value;
      setBump((b) => b + 1);
    }
  }, [value]);
  return (
    <span key={bump} className={`inline-block rounded-lg ${bump ? "num-bump" : ""} ${className}`} data-testid={testId}>
      {format(value)}
    </span>
  );
};

export const LiveDelta = ({ value, testId }) => {
  const { t } = useI18n();
  return value > 0 ? (
    <span className="inline-flex items-center gap-1 rounded-full bg-upv-light px-2 py-0.5 text-[11px] font-semibold text-upv" data-testid={testId}>
      {t("+{n} en esta sesión", { n: fmt(value) })}
    </span>
  ) : null;
};
